export default {
    title: "",
    unavailable: "Ez a termék már nem elérhető."
}